<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="card card-custom gutter-b card-stretch">
          <!--begin::Header-->
          <div class="card-header border-0">
            <h3 class="card-title font-weight-bolder text-dark">{{$t('user_detail.login_status')}}</h3>
            <div class="card-toolbar">
              <b-dropdown right  text="Üye Statü" class="mr-5" size="sm">
                <b-dropdown-item v-for="user_type in user_types" :key="user_type">
                  {{ user_type }}
                </b-dropdown-item>
              </b-dropdown>
              <b-button-group>
                <b-button size="sm"><i class="fas fa-sync mr-2"></i> Listeyi Yenile</b-button>
              </b-button-group>
            </div>
          </div>
          <!--end::Header-->
          <!--begin::Body-->
          <div class="card-body pt-2">
            <div class="row">
              <div class="col-md-12">
                <b-table
                    :bordered="table.bordered"
                    :outlined="table.outlined"
                    :small="table.small"
                    :hover="table.hover"
                    :fixed="table.fixed"
                    :items="table.items"
                    :head-variant="table.headvariant"
                ></b-table>
              </div>
            </div>
          </div>
          <!--end::Body-->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from "@/assets/components/dataTable/DataTable";

export default {
  name: "LoginLogs",
  components: {DataTable},
  data() {
    return {
      form : {
      },
      table : {
        bordered : true,
        outlined : true,
        small : true,
        fixed : true,
        hover : true,
        headvariant : 'light',
        items: [
          { 'Son Giriş Tarihi': '17.07.2020', 'IP Adresi': "198.162.1.1", 'İşlem': "Başarılı", 'Tip' : 'Email','Email': 'haygun@bilkent.edu.tr' },
          { 'Son Giriş Tarihi': '17.07.2020', 'IP Adresi': "198.162.1.1", 'İşlem': "Başarılı", 'Tip' : 'Email','Email': 'haygun@bilkent.edu.tr' },
          { 'Son Giriş Tarihi': '17.07.2020', 'IP Adresi': "198.162.1.1", 'İşlem': "Başarılı", 'Tip' : 'Email','Email': 'haygun@bilkent.edu.tr' },
          { 'Son Giriş Tarihi': '17.07.2020', 'IP Adresi': "198.162.1.1", 'İşlem': "Başarılı", 'Tip' : 'Email','Email': 'haygun@bilkent.edu.tr' },
          { 'Son Giriş Tarihi': '17.07.2020', 'IP Adresi': "198.162.1.1", 'İşlem': "Başarılı", 'Tip' : 'Email','Email': 'haygun@bilkent.edu.tr' },
          { 'Son Giriş Tarihi': '17.07.2020', 'IP Adresi': "198.162.1.1", 'İşlem': "Başarılı", 'Tip' : 'Email','Email': 'haygun@bilkent.edu.tr' },
          { 'Son Giriş Tarihi': '17.07.2020', 'IP Adresi': "198.162.1.1", 'İşlem': "Başarılı", 'Tip' : 'Email','Email': 'haygun@bilkent.edu.tr' },
          { 'Son Giriş Tarihi': '17.07.2020', 'IP Adresi': "198.162.1.1", 'İşlem': "Başarılı", 'Tip' : 'Email','Email': 'haygun@bilkent.edu.tr' },
          { 'Son Giriş Tarihi': '17.07.2020', 'IP Adresi': "198.162.1.1", 'İşlem': "Başarılı", 'Tip' : 'Email','Email': 'haygun@bilkent.edu.tr' },
          { 'Son Giriş Tarihi': '17.07.2020', 'IP Adresi': "198.162.1.1", 'İşlem': "Başarılı", 'Tip' : 'Email','Email': 'haygun@bilkent.edu.tr' },
          { 'Son Giriş Tarihi': '17.07.2020', 'IP Adresi': "198.162.1.1", 'İşlem': "Başarılı", 'Tip' : 'Email','Email': 'haygun@bilkent.edu.tr' },
          { 'Son Giriş Tarihi': '17.07.2020', 'IP Adresi': "198.162.1.1", 'İşlem': "Başarılı", 'Tip' : 'Email','Email': 'haygun@bilkent.edu.tr' },
        ],
      },
      user_types: [
        'Yeni Üye',
        'Aktif Üye',
        'Pasif Üye',
        'Fraud Yapan Üye',
        'Fraud Üyelik',
        'Çöp',
        "ST'de Silinmeyi İsteyen",
        "Napolyon'da Silinmeyi İsteyen",
      ],
    }
  },
};
</script>
